export interface AppConfig {
  apiUrl: string;
  apiBasePath: string;
  i18nUrl: string;
  keycloakAuthority: string;
  keycloakClientId: string;
  environment: string;
}

let config: AppConfig | null = null;

export function isConfigLoaded(): boolean {
  return config !== null;
}

export async function loadConfig(): Promise<AppConfig> {
  if (config) {
    return config;
  }

  try {
    const response = await fetch("/config.json");
    if (
      response.ok &&
      response.headers.get("content-type")?.includes("application/json")
    ) {
      const loaded: AppConfig = await response.json();
      config = loaded;
      return loaded;
    }
  } catch {
    // Production config not available; fall through to env vars
  }

  config = {
    apiUrl: import.meta.env.VITE_API_URL ?? "https://localhost:9443",
    apiBasePath: import.meta.env.VITE_API_BASE_PATH ?? "/api/v1",
    i18nUrl: import.meta.env.VITE_I18N_URL ?? "https://localhost:9443",
    keycloakAuthority:
      import.meta.env.VITE_KEYCLOAK_AUTHORITY ??
      "https://localhost:9443/realms/heke",
    keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "heke-ui",
    environment: import.meta.env.VITE_ENVIRONMENT ?? "development",
  };

  return config;
}

export function getConfig(): AppConfig {
  if (!config) {
    throw new Error("Configuration not loaded. Call loadConfig() first.");
  }
  return config;
}
